import {PRIMITIVE} from "core/metamodel/metaConstant";
import {IDomainObject} from "core/form/formUtils";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import { DATATYPE } from "core/metamodel/mdField";


export default class Chart extends DomainAncestor {

  data: {[key: string]: PRIMITIVE}[];
  columnsInfo: ColumnInfoDto[];
  entityName: string;

  constructor(json: IDomainObject) {
    super(json);
    if (!this.data) this.data = [];
  }
}

export interface ColumnInfoDto {
  id: string;
  isUsedOnGrid: boolean;
  effectiveHeaderLabel: string;
  dataType: DATATYPE;
}


// WEBPACK FOOTER //
// ./src/core/grid/domain/chart.ts